import {VNode} from 'snabbdom';

import {Translatable} from 'common/i18n';
import {LocalizationStore} from 'common/i18n/store';

export interface TooltipState {
  visibility: string;
  isFirstActiveTooltip: boolean;
}

export enum Placement {
  Top = `top`,
  Right = `right`,
  RightCenter = `right-center`,
  RightEnd = `right-end`,
  Bottom = `bottom`,
  Left = `left`,
  LeftCenter = `left-center`,
  LeftEnd = `left-end`,
}
export enum PositioningStrategy {
  Absolute = `absolute`,
  Fixed = `fixed`,
}

export enum DisplayType {
  Default = `default`,
  Error = `error`,
}
// LineDot arrow type adds a line to the left of the tooltip and currently does not work for all placements
export enum ArrowType {
  Default = `default`,
  LineDot = `line-dot`,
}

export enum TooltipTextAlign {
  Start = `start`,
  Center = `center`,
  End = `end`,
}
export enum DisplaySize {
  Small = `small`,
  Medium = `medium`,
  Large = `large`,

  Fit = `fit`,
}

export type TooltipAttrs = {
  'is-tooltip-tour'?: boolean;
  'always-show'?: boolean;
  'arrow-type'?: ArrowType;
  'break-word'?: boolean;
  'delay-in'?: number;
  'delay-out'?: number;
  'max-width'?: string;
  offset?: number;
  skidding?: number;
  placement?: Placement;
  type?: DisplayType;
  'image-src'?: string;
  size?: DisplaySize;
  text?: Translatable;
  'position-strategy'?: PositioningStrategy;
  'allowed-flip-directions'?: Placement[];
  'experimental-positioning'?: boolean;
  'text-align'?: TooltipTextAlign;
  'force-show'?: boolean;
};

export type TooltipParams = {
  text?: Translatable;
  placement?: Placement;
};

export interface TooltipJsxProps {
  attrs?: TooltipAttrs;
  params?: TooltipParams;
  on?: {
    showed: () => void;
  };
  props?: {
    /** for expensive components/templates that will only render when tooltip is visible */
    lazyContentRenderer?: (i18n: LocalizationStore) => VNode;
    parentEl?: HTMLElement;
  };
}
